module.exports = __webpack_public_path__ + "static/media/2DGACM6.f1e556a4.jpg";